<template>
    <app-text-field
        v-bind="$attrs"
        :value="value"
        :label="field.title"
        :rules="rules"
        :required="required"
        :counter="getMaxLength"
        v-on="$listeners" />
</template>

<script>
import formFieldMixin from "./formFieldMixin";

export default {
    types: [
        "string",
        "char",
        "phoneNumber"
    ],
    mixins: [formFieldMixin]
};
</script>
